/**
 * Reference models for cms-post-lib
 * 
 * @remarks
 * Lightweight reference models used when entities reference other entities.
 * Support both unpopulated (ID string) and populated (full object) references.
 */

/**
 * Minimal user reference (author, creator)
 */
export interface UserRef {
  _id: string;
  name: string;
  email: string;
  photoURL?: string;
}

/**
 * Minimal organization reference
 */
export interface OrganizationRef {
  _id: string;
  name: string;
  orgCode: string;
}

/**
 * Minimal post type reference
 */
export interface PostTypeRef {
  _id: string;
  typeName: string;
}

/**
 * Minimal blog post reference (for linked posts)
 */
export interface BlogPostRef {
  _id: string;
  title: string;
  slug: string;
  publishStatus: string;
  createdAt: string;
}

/**
 * Reaction type for comments
 */
export type ReactionType = 'like' | 'dislike' | 'love' | 'laugh' | 'angry' | 'sad';

/**
 * Comment reaction with author reference
 */
export interface Reaction {
  _id: string;
  type: ReactionType;
  authorId: UserRef | null;
  createdAt: string;
}
